<template>
  <article class="article article__text article--bg-corporate imprint">
    <h1>{{ $t('imprint.title') }}</h1>
    <h5>{{ $t('imprint.subtitle') }}</h5>
    <p>{{ $t('imprint.address') }}</p>
    <p v-html="$t('imprint.contact')"></p>
    <p>{{ $t('imprint.register') }}</p>
    <p v-html="$t('imprint.info')"></p>
    <p v-html="$t('imprint.participants')"></p>
    <p>{{ imprintText }}</p>
  </article>
</template>

<script>
  export default {
    name: 'Imprint',
    components: {},
    data() {
      return {
        date: new Date(),
        formattedDate: '',
        imprintText: ''
      }
    },
    metaInfo() {
      return {
        title: this.$t('imprint.meta_title'),
        meta: [
               { name: 'description', content:  this.$t('global.meta_description') },
               { name: 'keywords', content:  this.$t('global.meta_keywords') }
               ],
      }
    },
    mounted () {
      document.body.classList.add('body--bg-corporate')
      this.updateFormattedDate()
      this.updateImprintText()
    },
    destroyed () {
      document.body.classList.remove('body--bg-corporate')
    },
    updated () {
      this.$nextTick(() => {
        this.updateFormattedDate()
        this.updateImprintText()
      });
    },
    methods: {
      formatDate(date) {
        const options = { month: 'long', year: 'numeric' }
        const language = (this.$i18n.locale === 'en') ? 'en-GB' : 'de-DE'
        return new Intl.DateTimeFormat(language, options).format(date)
      },
      updateFormattedDate() {
        this.formattedDate = this.formatDate(this.date);
      },
      updateImprintText() {
        this.imprintText = this.$t('imprint.use').replace("{formattedDate}", this.formattedDate);
      }
    }
  }
</script>

<style lang="scss">
  .imprint {
    h1 {
      @include font-size(40);

      margin-bottom: 1em;
    }

    h2 {
      @include font-size(18);

      font-family: $corporate-font-family;
      left: 0;
      margin-left: 0;
      margin-top: 50px;
    }

    h5 {
      @include font-size(18);
    }

    p, a {
      font-family: $body-font-family;
    }

    p {
      white-space: pre-line;
    }
  }
</style>
